// IANA zone.tab "CA" entries plus legacy zones since merged into them.
const CANADIAN_TIME_ZONES = new Set([
  "America/St_Johns",
  "America/Halifax",
  "America/Glace_Bay",
  "America/Moncton",
  "America/Goose_Bay",
  "America/Blanc-Sablon",
  "America/Toronto",
  "America/Montreal",
  "America/Nipigon",
  "America/Thunder_Bay",
  "America/Iqaluit",
  "America/Pangnirtung",
  "America/Atikokan",
  "America/Winnipeg",
  "America/Rainy_River",
  "America/Resolute",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Swift_Current",
  "America/Edmonton",
  "America/Cambridge_Bay",
  "America/Yellowknife",
  "America/Inuvik",
  "America/Creston",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Dawson",
]);

export const detectCountry = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isCanada =
    CANADIAN_TIME_ZONES.has(timeZone) ||
    timeZone.startsWith("Canada/") ||
    navigator.language.endsWith("-CA");
  return isCanada ? "CA" : "US";
};

export const SCRIBEPHONE_CONSENT_MODES = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL",
};
